export default [
  {
    path: "/Reports/Guarantee",
    name: "Guarantee",
    component: () => import("@/views/pages/reports/Guarantee.vue"),
    props: true,
    meta: {
      pageTitle: "保證書套印",
      breadcrumb: [
        {
          text: "報表專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Reports/ReportControlfunds",
    name: "ReportControlfunds",
    component: () => import("@/views/pages/reports/ReportControlfunds.vue"),
    props: true,
    meta: {
      pageTitle: "專戶控管資金表",
      breadcrumb: [
        {
          text: "報表專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Reports/ReportControlfunds/:id",
    name: "ReportControlfunds-id",
    component: () => import("@/views/pages/reports/ReportControlfunds.vue"),
    props: true,
    meta: {
      pageTitle: "專戶控管資金表",
      breadcrumb: [
        {
          text: "報表專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Reports/ReportBalanceday",
    name: "ReportBalanceday",
    component: () => import("@/views/pages/reports/ReportBalanceday.vue"),
    props: true,
    meta: {
      pageTitle: "專戶餘額日報表",
      breadcrumb: [
        {
          text: "報表專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Reports/ReportContractinfo",
    name: "ReportContractinfo",
    component: () => import("@/views/pages/reports/ReportContractinfo.vue"),
    props: true,
    meta: {
      pageTitle: "契約資訊一覽表",
      breadcrumb: [
        {
          text: "報表專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Reports/ReportBrandsent",
    name: "ReportBrandsent",
    component: () => import("@/views/pages/reports/ReportBrandsent.vue"),
    props: true,
    meta: {
      pageTitle: "品牌送件統計表",
      breadcrumb: [
        {
          text: "報表專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Reports/ReportBillinfo",
    name: "ReportBillinfo",
    component: () => import("@/views/pages/reports/ReportBillinfo.vue"),
    props: true,
    meta: {
      pageTitle: "票據資訊一覽表",
      breadcrumb: [
        {
          text: "報表專區",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Reports/ReportPersontrack",
    name: "ReportPersontrack",
    component: () => import("@/views/pages/reports/ReportPersontrack.vue"),
    props: true,
    meta: {
      pageTitle: "個案動態追蹤表",
      breadcrumb: [
        {
          text: "報表專區",
          active: true,
        },
      ],
    },
  },
];
